import { FC, ChangeEvent, useRef, useState, useEffect } from 'react'
import './DocumentUploadCard.scss'

interface propTypes {
  description: string
  value?: (value: ChangeEvent<HTMLInputElement>) => void
  changeHandler: (value: ChangeEvent<HTMLInputElement>, doc: string) => void
  name: string
  doc: string
  checkIfExist: (value: string) => boolean
}

const DocumentUploadCard: FC<propTypes> = ({
  description,
  changeHandler,
  name,
  doc,
  checkIfExist,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [exists, setExists] = useState<boolean>(false)

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  // useEffect(() => {
  //   let mounted = true
  //   try {
  //     // call checkIfExist only when doc changes to avoid invoking it during render
  //     const result = typeof checkIfExist === 'function' ? checkIfExist(doc) : false
  //     if (mounted) setExists(!!result)
  //   } catch (e) {
  //     if (mounted) setExists(false)
  //   }
  //   return () => {
  //     mounted = false
  //   }
  //   // depend only on `doc` to avoid re-running when parent recreates the function
  // }, [doc])

  useEffect(() => {
    let mounted = true

    const result = checkIfExist(doc)
    if (mounted) setExists(!!result)

    return () => {
      mounted = false
    }
  }, [doc, checkIfExist])

  return (
    <div className='document-upload w-100'>
      <div className='document-desc'>{description}</div>
      <label className='mb-3 file-upload  mt-1' htmlFor={name}>
        <button type='button' className='btn btn-upload' onClick={handleButtonClick}>
          Add file
        </button>
        <input
          id={name}
          type='file'
          accept='image/*,.docx'
          className='form-control file-upload-input'
          onChange={(event) => changeHandler(event, doc)}
          name={name}
          ref={fileInputRef}
        />
      </label>
      {exists && <span className='d-icon d-check text-success fs-6 ms-3'></span>}
    </div>
  )
}

export default DocumentUploadCard
